import { Dashboard } from './dashboard';
import { CustomSideMenu1 } from './dashboard';
// ==============================|| MENU ITEMS ||============================== //
const isSdCustomAdmin = localStorage.getItem('isSdCustomAdmin');
const superDistributorMenuItems = {
    items: [isSdCustomAdmin === 'true' ? CustomSideMenu1 : Dashboard]
};

export default superDistributorMenuItems;
